export default () => {
    const elNavToggle = document.querySelector('[data-nav-toggle]')

    const openNav = () => {
        if (document.body.dataset.navState === 'open') {
            document.body.dataset.navState = 'closed'
            document.body.dataset.loginFormState = 'closed'
            return
        }

        document.body.dataset.navState = 'open'
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                document.body.dataset.navState = 'closed'
                document.body.dataset.loginFormState = 'closed'
            }
        })
    }

    const openLogin = () => {
        if (document.body.dataset.loginFormState === 'open') {
            document.body.dataset.loginFormState = 'closed'
            return
        }

        document.body.dataset.navState = 'open'
        document.body.dataset.loginFormState = 'open'
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                document.body.dataset.loginFormState = 'closed'
            }
        })
    }

    if (elNavToggle) {
        elNavToggle.addEventListener('click', () => {
            openNav()
        })

        window.addEventListener('load', () => {
            if (window.location.hash === '#login') {
                if (document.body.dataset.navState === 'closed') {
                    openLogin()
                }
            }
        })
    }

    const loginToggle = document.querySelectorAll('[data-login-form-toggle]')
    Array.from(loginToggle).forEach((toggle) => {
        toggle.addEventListener('click', e => {
            e.preventDefault()
            openLogin()
        })
    })
}
